import styled from 'styled-components';
import windowSize from '../../../../constants/WindowSize';
import { secondaryColor1 } from '../../../../../_metronic/variables.scss';

export const Container =styled.div`
  display: flex;
   justify-content: space-between;
  justify-content: ${({width}) => width >= windowSize.LG ? 'flex-end' : 'space-between'};
  align-items: center;
  padding:  ${({width, hasPadding}) => hasPadding
    ? width >= windowSize.LG ? '40px 40px 28px' : '24px'
    : width >= windowSize.LG ? '20px 0 0' : '20px 24px 0'};
  border-bottom: ${({width}) => width <= windowSize.SM ? `0.5px solid ${secondaryColor1+'4d'}` : ''};
`;
